// Mock data for Pelindo Makassar Vessel Tracking System

export const vessels = [
  {
    id: "v001",
    name: "MV TELUK BAYUR",
    mmsi: "525001001",
    imo: "9123456",
    callsign: "YCGX",
    lat: -5.1357,
    lon: 119.4078,
    sog: 12.5,
    cog: 285,
    heading: 283,
    shipType: "Cargo Ship",
    destination: "MAKASSAR",
    eta: "2025-01-15T08:00:00Z",
    status: "Underway",
    flag: "ID",
    draught: 8.5,
    length: 145,
    beam: 22
  },
  {
    id: "v002",
    name: "KM SIRIMAU",
    mmsi: "525002002",
    imo: "9234567",
    callsign: "YCHL",
    lat: -5.1156,
    lon: 119.4234,
    sog: 0,
    cog: 180,
    heading: 178,
    shipType: "Passenger Ship",
    destination: "SURABAYA",
    eta: "2025-01-16T14:00:00Z",
    status: "At Anchor",
    flag: "ID",
    draught: 6.2,
    length: 146,
    beam: 23
  },
  {
    id: "v003",
    name: "TB SENTOSA 12",
    mmsi: "525003003",
    imo: "9345678",
    callsign: "YCIM",
    lat: -5.1089,
    lon: 119.3956,
    sog: 5.8,
    cog: 45,
    heading: 47,
    shipType: "Tug Boat",
    destination: "MAKASSAR PORT",
    eta: "2025-01-14T16:00:00Z",
    status: "Underway",
    flag: "ID",
    draught: 4.5,
    length: 32,
    beam: 10
  },
  {
    id: "v004",
    name: "MV MERATUS MEDAN 2",
    mmsi: "525004004",
    imo: "9456789",
    callsign: "YCJN",
    lat: -5.1245,
    lon: 119.4512,
    sog: 14.2,
    cog: 270,
    heading: 268,
    shipType: "Container Ship",
    destination: "MAKASSAR",
    eta: "2025-01-14T22:00:00Z",
    status: "Underway",
    flag: "ID",
    draught: 9.8,
    length: 168,
    beam: 27
  },
  {
    id: "v005",
    name: "KM UMSINI",
    mmsi: "525005005",
    imo: "9567890",
    callsign: "YCKO",
    lat: -5.1423,
    lon: 119.4156,
    sog: 0,
    cog: 90,
    heading: 92,
    shipType: "Passenger Ship",
    destination: "BALIKPAPAN",
    eta: "2025-01-15T06:00:00Z",
    status: "Moored",
    flag: "ID",
    draught: 5.8,
    length: 130,
    beam: 21
  },
  {
    id: "v006",
    name: "MT PERTAMINA PRIDE",
    mmsi: "525006006",
    imo: "9678901",
    callsign: "YCLP",
    lat: -5.0987,
    lon: 119.3845,
    sog: 8.5,
    cog: 315,
    heading: 312,
    shipType: "Tanker",
    destination: "MAKASSAR",
    eta: "2025-01-14T18:00:00Z",
    status: "Underway",
    flag: "ID",
    draught: 11.2,
    length: 183,
    beam: 32
  },
  {
    id: "v007",
    name: "KM LAMBELU",
    mmsi: "525007007",
    imo: "9789012",
    callsign: "YCMQ",
    lat: -5.1567,
    lon: 119.4289,
    sog: 0,
    cog: 0,
    heading: 355,
    shipType: "Passenger Ship",
    destination: "BAUBAU",
    eta: "2025-01-15T10:00:00Z",
    status: "Moored",
    flag: "ID",
    draught: 5.5,
    length: 146,
    beam: 23
  },
  {
    id: "v008",
    name: "MV SINAR JAYA",
    mmsi: "525008008",
    imo: "9890123",
    callsign: "YCNR",
    lat: -5.0856,
    lon: 119.4423,
    sog: 11.3,
    cog: 225,
    heading: 222,
    shipType: "Cargo Ship",
    destination: "MAKASSAR",
    eta: "2025-01-14T20:00:00Z",
    status: "Underway",
    flag: "ID",
    draught: 7.8,
    length: 120,
    beam: 18
  },
  {
    id: "v009",
    name: "TB BINTANG SAMUDRA",
    mmsi: "525009009",
    imo: "9901234",
    callsign: "YCOS",
    lat: -5.1312,
    lon: 119.3789,
    sog: 6.2,
    cog: 135,
    heading: 138,
    shipType: "Tug Boat",
    destination: "MAKASSAR PORT",
    eta: "2025-01-14T15:30:00Z",
    status: "Underway",
    flag: "ID",
    draught: 4.2,
    length: 28,
    beam: 9
  },
  {
    id: "v010",
    name: "MV TANTO EXPRESS",
    mmsi: "525010010",
    imo: "9012345",
    callsign: "YCPT",
    lat: -5.1678,
    lon: 119.4567,
    sog: 0,
    cog: 180,
    heading: 182,
    shipType: "Container Ship",
    destination: "JAKARTA",
    eta: "2025-01-16T02:00:00Z",
    status: "At Anchor",
    flag: "ID",
    draught: 8.9,
    length: 155,
    beam: 24
  }
];

export const geofences = [
  {
    id: "gf001",
    name: "Pelabuhan Makassar - Area Utama",
    type: "port",
    portAreaType: "Harbor",
    createdAt: "2024-06-15T00:00:00Z",
    polygonCoords: [
      [-5.145, 119.410],
      [-5.145, 119.430],
      [-5.125, 119.430],
      [-5.125, 119.410],
      [-5.145, 119.410]
    ],
    color: "#1E88C7",
    autoGate: true
  },
  {
    id: "gf002",
    name: "Area Labuh Jangkar",
    type: "anchorage",
    portAreaType: "Anchorage",
    createdAt: "2024-06-20T00:00:00Z",
    polygonCoords: [
      [-5.110, 119.440],
      [-5.110, 119.470],
      [-5.080, 119.470],
      [-5.080, 119.440],
      [-5.110, 119.440]
    ],
    color: "#43A047",
    autoGate: false
  },
  {
    id: "gf003",
    name: "Zona Pandu",
    type: "pilot",
    portAreaType: "Pilot",
    createdAt: "2024-07-01T00:00:00Z",
    polygonCoords: [
      [-5.100, 119.380],
      [-5.100, 119.420],
      [-5.070, 119.420],
      [-5.070, 119.380],
      [-5.100, 119.380]
    ],
    color: "#FB8C00",
    autoGate: true
  },
  {
    id: "gf004",
    name: "Terminal Peti Kemas",
    type: "terminal",
    portAreaType: "Container Terminal",
    createdAt: "2024-07-10T00:00:00Z",
    polygonCoords: [
      [-5.140, 119.400],
      [-5.140, 119.415],
      [-5.130, 119.415],
      [-5.130, 119.400],
      [-5.140, 119.400]
    ],
    color: "#8E24AA",
    autoGate: true
  }
];

export const stations = [
  {
    id: "st001",
    name: "Stasiun Pandu Utama",
    areaType: "pilot",
    maxSpeed: 8,
    boundaryCoords: [
      [-5.135, 119.412],
      [-5.135, 119.422],
      [-5.128, 119.422],
      [-5.128, 119.412],
      [-5.135, 119.412]
    ]
  },
  {
    id: "st002",
    name: "Anchorage Alpha",
    areaType: "anchorage",
    maxSpeed: 3,
    boundaryCoords: [
      [-5.095, 119.445],
      [-5.095, 119.465],
      [-5.085, 119.465],
      [-5.085, 119.445],
      [-5.095, 119.445]
    ]
  },
  {
    id: "st003",
    name: "Anchorage Bravo",
    areaType: "anchorage",
    maxSpeed: 3,
    boundaryCoords: [
      [-5.105, 119.450],
      [-5.105, 119.468],
      [-5.095, 119.468],
      [-5.095, 119.450],
      [-5.105, 119.450]
    ]
  },
  {
    id: "st004",
    name: "Harbor Basin",
    areaType: "harbor",
    maxSpeed: 5,
    boundaryCoords: [
      [-5.142, 119.415],
      [-5.142, 119.428],
      [-5.132, 119.428],
      [-5.132, 119.415],
      [-5.142, 119.415]
    ]
  }
];

export const anomalies = [
  {
    id: "an001",
    type: "invalid_mmsi",
    vesselId: "unknown001",
    vesselName: "Unknown Vessel",
    mmsi: "123456789",
    imo: "N/A",
    date: "2025-01-14T08:30:00Z",
    reason: "MMSI tidak valid - tidak sesuai format Indonesia",
    severity: "high"
  },
  {
    id: "an002",
    type: "invalid_imo",
    vesselId: "unknown002",
    vesselName: "MV MYSTERY",
    mmsi: "525099099",
    imo: "0000000",
    date: "2025-01-14T07:15:00Z",
    reason: "IMO number tidak valid atau tidak terdaftar",
    severity: "medium"
  },
  {
    id: "an003",
    type: "invalid_callsign",
    vesselId: "unknown003",
    vesselName: "TB FREEDOM",
    mmsi: "525088088",
    imo: "9111222",
    date: "2025-01-14T06:45:00Z",
    reason: "Callsign tidak sesuai dengan data registrasi",
    severity: "low"
  },
  {
    id: "an004",
    type: "stay_long_time",
    vesselId: "v010",
    vesselName: "MV TANTO EXPRESS",
    mmsi: "525010010",
    imo: "9012345",
    date: "2025-01-14T00:00:00Z",
    reason: "Kapal berlabuh lebih dari 72 jam tanpa aktivitas",
    severity: "medium"
  },
  {
    id: "an005",
    type: "invalid_mmsi",
    vesselId: "unknown004",
    vesselName: "Unknown Fishing Vessel",
    mmsi: "999999999",
    imo: "N/A",
    date: "2025-01-13T22:00:00Z",
    reason: "MMSI menggunakan format reserved/test",
    severity: "high"
  },
  {
    id: "an006",
    type: "stay_long_time",
    vesselId: "v002",
    vesselName: "KM SIRIMAU",
    mmsi: "525002002",
    imo: "9234567",
    date: "2025-01-12T14:00:00Z",
    reason: "Kapal dalam status At Anchor lebih dari 48 jam",
    severity: "low"
  },
  {
    id: "an007",
    type: "invalid_imo",
    vesselId: "unknown005",
    vesselName: "MV PHANTOM",
    mmsi: "525077077",
    imo: "1234567",
    date: "2025-01-13T18:30:00Z",
    reason: "IMO check digit tidak valid",
    severity: "high"
  }
];

export const gateEvents = [
  {
    id: "ge001",
    geofenceId: "gf001",
    vesselId: "v001",
    vesselName: "MV TELUK BAYUR",
    eventType: "enter",
    timestamp: "2025-01-14T06:30:00Z"
  },
  {
    id: "ge002",
    geofenceId: "gf001",
    vesselId: "v004",
    vesselName: "MV MERATUS MEDAN 2",
    eventType: "enter",
    timestamp: "2025-01-14T05:45:00Z"
  },
  {
    id: "ge003",
    geofenceId: "gf003",
    vesselId: "v006",
    vesselName: "MT PERTAMINA PRIDE",
    eventType: "enter",
    timestamp: "2025-01-14T04:20:00Z"
  },
  {
    id: "ge004",
    geofenceId: "gf001",
    vesselId: "v003",
    vesselName: "TB SENTOSA 12",
    eventType: "exit",
    timestamp: "2025-01-14T03:15:00Z"
  },
  {
    id: "ge005",
    geofenceId: "gf002",
    vesselId: "v010",
    vesselName: "MV TANTO EXPRESS",
    eventType: "enter",
    timestamp: "2025-01-13T22:00:00Z"
  },
  {
    id: "ge006",
    geofenceId: "gf003",
    vesselId: "v008",
    vesselName: "MV SINAR JAYA",
    eventType: "exit",
    timestamp: "2025-01-14T02:30:00Z"
  }
];

export const pastTracks = {
  v001: [
    { lat: -5.180, lon: 119.350, timestamp: "2025-01-14T00:00:00Z" },
    { lat: -5.170, lon: 119.365, timestamp: "2025-01-14T01:00:00Z" },
    { lat: -5.160, lon: 119.380, timestamp: "2025-01-14T02:00:00Z" },
    { lat: -5.150, lon: 119.395, timestamp: "2025-01-14T03:00:00Z" },
    { lat: -5.1357, lon: 119.4078, timestamp: "2025-01-14T04:00:00Z" }
  ],
  v004: [
    { lat: -5.100, lon: 119.500, timestamp: "2025-01-14T00:00:00Z" },
    { lat: -5.105, lon: 119.485, timestamp: "2025-01-14T01:00:00Z" },
    { lat: -5.115, lon: 119.470, timestamp: "2025-01-14T02:00:00Z" },
    { lat: -5.120, lon: 119.460, timestamp: "2025-01-14T03:00:00Z" },
    { lat: -5.1245, lon: 119.4512, timestamp: "2025-01-14T04:00:00Z" }
  ]
};

// Helper functions
export const getVesselById = (id) => vessels.find(v => v.id === id);

export const getGeofenceById = (id) => geofences.find(g => g.id === id);

export const getStationById = (id) => stations.find(s => s.id === id);

export const getVesselsInGeofence = (geofenceId) => {
  const geofence = getGeofenceById(geofenceId);
  if (!geofence) return [];
  
  // Simplified point-in-polygon check for demo
  return vessels.filter(vessel => {
    const coords = geofence.polygonCoords;
    const minLat = Math.min(...coords.map(c => c[0]));
    const maxLat = Math.max(...coords.map(c => c[0]));
    const minLon = Math.min(...coords.map(c => c[1]));
    const maxLon = Math.max(...coords.map(c => c[1]));
    
    return vessel.lat >= minLat && vessel.lat <= maxLat &&
           vessel.lon >= minLon && vessel.lon <= maxLon;
  });
};

export const getAnomaliesByType = (type) => anomalies.filter(a => a.type === type);

export const getGateEventsByGeofence = (geofenceId) => 
  gateEvents.filter(e => e.geofenceId === geofenceId);

export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'underway':
      return 'vessel-active';
    case 'at anchor':
    case 'anchored':
      return 'vessel-anchored';
    case 'moored':
      return 'info';
    default:
      return 'muted';
  }
};

export const getSeverityColor = (severity) => {
  switch (severity?.toLowerCase()) {
    case 'high':
      return 'destructive';
    case 'medium':
      return 'warning';
    case 'low':
      return 'info';
    default:
      return 'muted';
  }
};
